module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.6493/images/default-company-avatar.png"